import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import dynamicSocketUrl from "../../../config/socketUrl";
import { toast } from "react-toastify";
import { addqrOrder,fetchqrOrderList } from "../../../redux/slice/qrMenuSlice";


const useQrOrderSSE = () => {
  const dispatch = useDispatch();
  const [newQrOrderCount, setNewQrOrderCount] = useState(0);

  useEffect(() => {
    const eventSource = new EventSource(
      `${dynamicSocketUrl()}/bbgapi/sse`,
      { withCredentials: true }
    );

  

    // 🔥 Listen to qrOrder event
    eventSource.addEventListener("qrOrder", (event) => {
      const data = JSON.parse(event.data);

      // Option 1: Push single order instantly
      if (data.order) {
        dispatch(addqrOrder(data.order));
      }

      // Option 2 (safer): refetch whole list
      dispatch(fetchqrOrderList());

      setNewQrOrderCount((prev) => prev + 1);

      toast.success(data.message || "New QR order received", {
        position: "top-right",
      });
    });

    eventSource.onerror = (err) => {
      // console.error("QR SSE error", err);
    };

    return () => {
      eventSource.close();
    };
  }, [dispatch]);

  const resetQrOrderCount = () => setNewQrOrderCount(0);

  return { newQrOrderCount, resetQrOrderCount };
};

export default useQrOrderSSE;
